<template>
    <div class="BPChecklistsEditor">
		<card>
			<div class="">
				<h5><i class="tim-icons icon-send text-success mr-3"></i>Добавить чеклист в таблицу</h5>
			</div>
			
			<div>
				<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Добавить чеклист" />
			</div>
		</card>
		<card>
			<el-table :data="ApiData" style="width: 100%;">
			<el-table-column
				label="ID"
				property="id"
				width="80"
				sortable
			>
			</el-table-column>
			<el-table-column
				label="act"
				property="act"
				width="80"
				sortable
			>
			</el-table-column>
			<!--
			<el-table-column
				label="bp_id"
				property="bp_id"
				width="80"
				sortable
			>
			</el-table-column>
			-->
			<el-table-column 
				min-width="180"
				label="name"
				property="name"
				sortable
			>
			</el-table-column>
			<el-table-column 
				min-width="180"
				label="filename"
				property="filename"
				sortable
			>
			</el-table-column>
			<el-table-column 
				min-width="180"
				label="obj"
				property="obj"
				sortable
			>
			</el-table-column>
			<el-table-column 
				min-width="180"
				label="method"
				property="method"
				sortable
			>
			</el-table-column>
			<el-table-column 
				min-width="180"
				label="flt"
				property="flt"
				sortable
			>
			</el-table-column>
			<el-table-column 
				min-width="180"
				label="obj_destination"
				property="obj_destination"
				sortable
			>
			</el-table-column>
			<el-table-column 
				min-width="180"
				label="save_to_serv"
				property="save_to_serv"
				sortable
			>
				<template v-slot="scope">
					{{saveToServ(scope.row.save_to_serv)}}
				</template>			
			</el-table-column>			
			
			<el-table-column
					width="180"
					label="Действие"
					align="right"                    	
			>
				<template v-slot="scope">		
					<ReActionBtns :masActions="masActions[scope.$index]"/>
					<!-- <el-tooltip content="Удалить" placement="top">
						<el-button class="no-border my-0">
							<button class="ml-3 btn btn-icon btn-simple btn-danger" disabled @click="DeleteRow(scope.row)">
								<i class="tim-icons icon-trash-simple"></i>
							</button>											
						</el-button>
					</el-tooltip>							 -->
				</template>
			</el-table-column>			
			</el-table>
			<Pagination class="mt-3" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masObjects_total)*parseInt(count2page)" 
				:perPage="parseInt(count2page)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination>
		</card>
    </div>
</template>
<script>

// import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import { BaseSwitch } from 'src/components/index';
// import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
// import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
import Pagination from 'src/our_components/RePagination';
import ReActionBtns from 'src/our_components/ReActionBtns.vue';

export default {
	name: 'bp_checklists_editor-page',
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		// BaseSwitch,
		// ReFilterBtn,
        // ReFilter,
        ReFormPrinter,
        Pagination,
		ReActionBtns,

	},
	data() {
		return {
			ApiData: [],
			masAllFormParams: this.currentFormConfig(),
			currentApiFormMethod: this.currentApiFormMethodComp(),
			objGetParams:{},
			masObjects_total: 0,
			count2page: 10,
			masActions:[],	
			// saveToServName:'',
		};
	},
	methods: {
		getApiData(){
			this.$GVO.ApiCall('BP_CHECKLIST.GET',{flt:{'id':'true','c2p':50}} )
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						this.masObjects_total = objApi.countpage;
						let saveToServName = '';

						this.masActions = [];
						for (let i = 0; i < this.ApiData.length; i++) {
							this.masActions.push([
								{
									actionType: 'switcher',
									label_on: 'Вкл',
									label_off: 'Выкл',
									action_model: this.ApiData[i].act=='1'?true:false,						
									onClickApi: {apiMethod: 'CHANGE_CHECKLIST_ACT',apiParam:{obj:'BP_CHECKLIST',flt:{id:this.ApiData[i].id}}},
								},
								{
									actionType: 'btn_del',
									onClickApi: {apiMethod:'DEL',apiParam:{obj:'BP_CHECKLIST',flt:{id:this.ApiData[i].id}}},
								},
							]);							
						}
					}else{
						this.ApiData = [];
						this.masObjects_total=0;
					}
				}else{
					this.ApiData = [];
					this.masObjects_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
		},
		currentFormConfig() {
			this.$GVO.ApiCall('BP_CHECKLIST.GET_FORM_MODEL',{})
				.then((objApi) => {
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentApiFormMethodComp(){
            return {apiMethod:'BP_CHECKLIST.INS',apiParam:{iData:[]}};
        },
		SuccessGo(evt,dopParam){
			this.masAllFormParams = this.currentFormConfig();
			this.getApiData();
		},		
		saveToServ(save_to_serv){	
			// console.log(save_to_serv);		
			let saveToServName = '';
			if(save_to_serv == 0) {
				saveToServName = 'не сохраняем на услугу';
			} else if(save_to_serv == 1) {
				saveToServName = 'сохраняем';
			} else {
				saveToServName = 'сохраняем как синглетрон';
			}

			return saveToServName;
		},
		// DeleteRow(row){
		// 	if(row.id != null){
		// 		this.$GVO.ApiCall('BP_CHECKLIST.DEL',{ flt:{id: row.id}}) 
		// 			.then((objApi) => {
		// 				if(objApi.success === true){
		// 					this.getApiData();
		// 				}else{
		// 					alert('Не удалилось');
		// 				}
		// 			}).catch(errorObjApi => {console.log(errorObjApi);});
		// 	}
		// },
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			// this.OnFilterApply();
		},
		// GoEdit(row){
		// 	if(row.id != null){
		// 		this.$router.push({path: this.$GVO.str_replace('/helpdesk','/helpdeskstaff',location.pathname)+'/'+row.id});
		// 	}
		// }
	},		
	mounted() {
		this.getApiData();
	}
};
</script>
<style>
.BPChecklistsEditor .bntGroup {
	display: flex;
	justify-content: flex-end;
}
.BPChecklistsEditor .form-options-group{
	flex-direction: row;
	width: 100%;
	align-items: center;
	flex-wrap: wrap;
}
.BPChecklistsEditor .form-options-group > div{
	margin-right: 5px;
}
.BPChecklistsEditor .form-group {
	margin-bottom: 0px!important;
}
.BPChecklistsEditor-table .cell, .Cellraspred-table button {
	word-break: break-word!important;
}


</style>
